import React, { useState } from "react";

import {
  useNotify,
  Confirm,
  SaveButton,
  FormDataConsumer,
  useRedirect,
} from "react-admin";
import { useForm, useFormState } from "react-final-form";

import { logError } from "../../../utils/appUtils";
import { VALIDATION_MSG } from "../../../utils/constants";

export const DialogSaveButton = ({ backPath, inventory, ...props }) => {
  const form = useForm();
  const { pristine, submitting } = useFormState({
    subscription: { pristine: true, submitting: true },
  });
  const notify = useNotify();
  const redirect = useRedirect();
  const [open, setOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState("");

  const formValidate = () => {
    debugger;
    const newFormState = form.getState();
    if (newFormState.invalid) notify(VALIDATION_MSG, "warning");
  };

  const handleValidateSave = (formData) => {
    debugger;
    // if (validateNotes(form, formData)) {
    //     const tempMsg = "Don't forget to document all Quantity changes in the Notes! " +
    //         "Do you want to proceed without adding a Note?";
    //     setMessage(tempMsg);
    //     setOpen(true);
    // } else
    setMessage(""); // not needed
    handleSave();
  };
  const handleDialogClose = () => setOpen(false);

  const handleSave = () => {
    formValidate();
    setOpen(false);

    props.handleSubmitWithRedirect();
  };

  const transform = async (data) => {
    setIsSaving(true);
    data = { ...data };
    return data;
  };

  const onSuccess = async (data) => {
    setIsSaving(false);
    notify("Commodity updated successfully", "success");
    redirect("list", "/commoditys");
  };

  const onFailure = (error) => {
    setIsSaving(false);
    logError("commoditys:DialogSaveButton:onFailure", error, notify);
  };

  // Pass ...props, not ...rest to FormDataConsumer to include handleSubmitWithRedirect from props
  return (
    <FormDataConsumer>
      {({ formData, ...props }) => (
        <>
          <SaveButton
            label="Save"
            submitOnEnter={false}
            undoable={false}
            disabled={pristine}
            saving={isSaving || submitting}
            handleSubmitWithRedirect={() => handleValidateSave(formData)}
            transform={transform}
            onSuccess={onSuccess}
            onFailure={onFailure}
          />
          <Confirm
            isOpen={open}
            loading={isSaving || submitting}
            title="Save Confirmation"
            content={message}
            onConfirm={handleSave}
            onClose={handleDialogClose}
          />
        </>
      )}
    </FormDataConsumer>
  );
};
